// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__GSC+r","link":"tweet-replies_link__zxNP8","text":"tweet-replies_text__RHy35"};